// extracted by mini-css-extract-plugin
module.exports = {"container":"modal-info_container__15mpK","innerBody":"modal-info_innerBody__kL3rc"};